import React from 'react'
import { connect } from 'react-redux'
import { ListGroup, Panel } from 'react-bootstrap'

import { createTripNote, editTripNote, removeTripNote } from '../ducks/trips'
import Button from '../components/Button.jsx'

import MarkdownField from '../lib/MarkdownField'
import { getText } from '../lib/text.js'

/**
 *
 */

type Props = {
  trip: Object,
  panel: ?boolean,

  // from connect
  username: string, 
  create: Function, 
  edit: Function, 
  remove: Function
}

const Wrapper = ({ panel, children }) => (
  panel 
    ? (
      <Panel>
        <Panel.Heading>
          <Panel.Title>{getText("Comentarios")}</Panel.Title>
        </Panel.Heading>
        <Panel.Body>
          {children}
        </Panel.Body>
      </Panel>
    )
    : <div>{children}</div>
)

//const TripNotes = (: Props) => {
class TripNotesEditor extends React.PureComponent {
  constructor(props) {
    super(props)
    this.state = { 
      openNote: null 
    }
  }

  props: Props 

  render() {
    const {trip, username, create, edit, remove} = this.props

    return (
      <Wrapper panel={this.props.panel}>
        <ListGroup>
          {
            trip.notes.length == 0 
              ? (<em>{getText("No hay comentarios")}</em>)
              : trip.notes.map(note => (
                <MarkdownField 
                  key={note.id} 
                  label={
                    <div>
                      <span style={{opacity: note.pinned ? 1 : 0.4, marginRight: 4}}>📌</span>
                      <span>{note.author}, {note.creation}{" "}</span>
                      <small>
                        <a href="#" style={{ marginLeft: 4 }} onClick={() => edit(note.id, { pinned: !note.pinned })}>
                          {getText("Fijar")}
                        </a>
                        <a href="#" style={{ marginLeft: 4 }} onClick={() => this.setState({ openNote: note.id })}>
                          {getText("Editar")}
                        </a>
                        <a href="#" style={{ marginLeft: 4, color: "red" }} onClick={() => remove(note.id)}>
                          {getText("Eliminar")}
                        </a>
                      </small>
                    </div>
                  }
                  value={note.text}
                  onChange={text => edit(note.id, { text })}
                  forceOpen={this.state.openNote == note.id}
                />
              ))
          }
        </ListGroup>
        <Button 
          glyph="plus"
          onClick={() => create(username, id => this.setState({ openNote: id }))}
        >
          {getText("Añadir comentario")}
        </Button>
      </Wrapper>
    )
  }
}

const stateToProps = (state, props) => ({
  username: state.loginData.username
})

const dispatchToProps = (dispatch, props) => ({
  create: (author, idCallback) => dispatch(createTripNote(props.trip._id, { author }, idCallback)),
  edit: (noteId, changes) => dispatch(editTripNote(props.trip._id, noteId, changes)), 
  remove: (noteId) => dispatch(removeTripNote(props.trip._id, noteId)), 
})

export default connect(stateToProps, dispatchToProps)(TripNotesEditor)
